var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"traffic-container"},[_c('div',{staticStyle:{"height":"100%","width":"98%"},attrs:{"id":"carThroughput"}})])
}]

export { render, staticRenderFns }